import { ColumnConfig, ColumnDataType } from '@aurora';

export const aircraftModelColumnsConfig: ColumnConfig[] = [
    {
        type       : ColumnDataType.STRING,
        field      : 'name',
        sort       : 'name',
        translation: 'Name',
        isUnaccent : true,
    },
    {
        type       : ColumnDataType.NUMBER,
        field      : 'totalMotors',
        sort       : 'totalMotors',
        translation: 'digitai.TotalMotors',
    },
];
